import Breadcrumbs, { Crumb } from '@liveauctioneers/caterwaul-components/lib/Breadcrumbs/Breadcrumbs';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import useIsNarrowerThan from '@/hooks/useIsNarrowerThan';
import { mergedCaterwaulAndHammerUIThemes } from '@/theme/mergedCaterwaulAndHammerUIThemes';

type Props = {
    className?: string;
    crumbs: Crumb[];
};

// This breadcrumb wrapper is to provide consistent styles and less code duplication for breadcrumbs that are used
// across the app, except for the item page.
export const BreadcrumbWrapper = ({ className, crumbs }: Props) => {
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = mergedCaterwaulAndHammerUIThemes;
    const narrow = useIsNarrowerThan(tabletNarrowWidthNum + 1);

    if (!narrow) {
        return (
            <Breadcrumbs
                className={cn('mx-auto my-lg w-[calc(100%-40px)] max-w-[1240px]', className)}
                crumbs={crumbs}
            />
        );
    }

    return (
        <div
            className={cn(
                'relative z-[1] mx-md my-lg flex h-[18px] max-w-[1200px] items-center justify-between overflow-hidden',
                className
            )}
        >
            <div
                style={{ overflow: '-moz-scrollbars-none' }}
                className="m-0 inline-block w-full overflow-x-auto overflow-y-hidden whitespace-nowrap"
            >
                <Breadcrumbs crumbs={crumbs} />
            </div>
        </div>
    );
};
